import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import type { FlatListTableProps, ListTableAction, ListTableColumn } from 'framework/ui/ui-builder';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';
import { MinusIcon } from 'framework/ui/mui-builder';
import type { TaskConstructorListItem } from '../types';

const columns: ListTableColumn<TaskConstructorListItem>[] = [
  {
    id: 'domain',
    label: 'Domain',
    render: request => request.domain,
  },
  {
    id: 'object',
    label: 'Object',
    render: request => request.object,
  },
  {
    id: 'currentState',
    label: 'Current state',
    render: request => request.currentState,
  },
  {
    id: 'targetState',
    label: 'Target state',
    render: request => request.targetState,
  },
  {
    id: 'action',
    label: 'Action',
    render: request => request.action || EMPTY_VALUE_INDICATOR,
  },
];

const actions: ListTableAction<TaskConstructorListItem>[] = [
  {
    id: 'edit-task-constructor',
    label: 'Edit task',
    icon: <EditOutlinedIcon />,
    variant: 'outlined',
    tooltip: 'Edit task in constructor',
    onClick: () => {},
  },
  {
    id: 'remove-task',
    label: 'Remove',
    icon: <MinusIcon />,
    variant: 'outlined',
    tooltip: 'Remove task',
    onClick: () => {},
  },
];

export const getTaskConstructorTableConfig = (
  rows: TaskConstructorListItem[],
  onCreate: () => void,
): FlatListTableProps<TaskConstructorListItem> => ({
  rows,
  columns,
  rowActions: { actions, width: 72 },
  mainAction: {
    id: 'create-task-constructor',
    label: 'Create task',
    icon: <AddOutlinedIcon />,
    variant: 'contained',
    tooltip: 'Create task in constructor',
    onClick: onCreate,
  },
  rowHeight: 46,
  isRowHighlighted: row => !!row.isNew,
});
